import { render, staticRenderFns } from "./FillblanksModule.vue?vue&type=template&id=2145bade&scoped=true&"
import script from "./FillblanksModule.vue?vue&type=script&lang=js&"
export * from "./FillblanksModule.vue?vue&type=script&lang=js&"
import style0 from "./FillblanksModule.vue?vue&type=style&index=0&id=2145bade&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145bade",
  null
  
)

export default component.exports